import { create, get } from "lodash";

const actions = {
    // Cajas
    GET_CAJAS_REQUEST: 'GET_CAJAS_REQUEST',
    GET_CAJAS_SUCCESS: 'GET_CAJAS_SUCCESS',
    EDIT_CAJA_REQUEST: 'EDIT_CAJA_REQUEST',
    EDIT_CAJA_SUCCESS: 'EDIT_CAJA_SUCCESS',
    DELETE_CAJA_REQUEST: 'DELETE_CAJA_REQUEST',
    DELETE_CAJA_SUCCESS: 'DELETE_CAJA_SUCCESS',

    // Cuentas
    GET_CUENTAS_REQUEST: 'GET_CUENTAS_REQUEST',
    GET_CUENTAS_SUCCESS: 'GET_CUENTAS_SUCCESS',
    CREATE_CUENTA_REQUEST: 'CREATE_CUENTA_REQUEST',
    CREATE_CUENTA_SUCCESS: 'CREATE_CUENTA_SUCCESS',
    EDIT_CUENTA_REQUEST: 'EDIT_CUENTA_REQUEST',
    EDIT_CUENTA_SUCCESS: 'EDIT_CUENTA_SUCCESS',
    DELETE_CUENTA_REQUEST: 'DELETE_CUENTA_REQUEST',
    DELETE_CUENTA_SUCCESS: 'DELETE_CUENTA_SUCCESS',

    // Movimientos
    CREATE_MOVIMIENTO_REQUEST: 'CREATE_MOVIMIENTO_REQUEST',
    CREATE_MOVIMIENTO_SUCCESS: 'CREATE_MOVIMIENTO_SUCCESS',
    GET_MOVIMIENTOS_REQUEST: 'GET_MOVIMIENTOS_REQUEST',
    GET_MOVIMIENTOS_SUCCESS: 'GET_MOVIMIENTOS_SUCCESS',
    SET_PAGINATION_INFO_MOVIMIENTOS: 'SET_PAGINATION_INFO_MOVIMIENTOS',
    GET_MOVIMIENTOS_INFORMES_REQUEST: 'GET_MOVIMIENTOS_INFORMES_REQUEST',
    GET_MOVIMIENTOS_INFORMES_SUCCESS: 'GET_MOVIMIENTOS_INFORMES_SUCCESS',
    EDIT_MOVIMIENTO_REQUEST: 'EDIT_MOVIMIENTO_REQUEST',
    EDIT_MOVIMIENTO_SUCCESS: 'EDIT_MOVIMIENTO_SUCCESS',
    DELETE_MOVIMIENTO_REQUEST: 'DELETE_MOVIMIENTO_REQUEST',
    DELETE_MOVIMIENTO_SUCCESS: 'DELETE_MOVIMIENTO_SUCCESS',

    // Cierres
    GET_CIERRES_REQUEST: 'GET_CIERRES_REQUEST',
    GET_CIERRES_SUCCESS: 'GET_CIERRES_SUCCESS',
    CREATE_CIERRE_REQUEST: 'CREATE_CIERRE_REQUEST',
    CREATE_CIERRE_SUCCESS: 'CREATE_CIERRE_SUCCESS',
    UPDATE_CIERRE_REQUEST: 'UPDATE_CIERRE_REQUEST',
    UPDATE_CIERRE_SUCCESS: 'UPDATE_CIERRE_SUCCESS',
    CREATE_CIERRE_REQUEST: 'CREATE_CIERRE_REQUEST',
    CREATE_CIERRE_SUCCESS: 'CREATE_CIERRE_SUCCESS',

    // Saldos
    GET_SALDOS_REQUEST: 'GET_SALDOS_REQUEST',
    GET_SALDOS_SUCCESS: 'GET_SALDOS_SUCCESS',

    getCuentas: (data, history) => ({
        type: actions.GET_CUENTAS_REQUEST,
        payload: data,
        history
    }),
    createCuenta: (data) => ({
        type: actions.CREATE_CUENTA_REQUEST,
        payload: data,
    }),
    editCuentas: (id, payload) => ({
        type: actions.EDIT_CUENTA_REQUEST,
        id,
        payload
    }),
    deleteCuentaa: id => ({
        type: actions.DELETE_CUENTA_REQUEST,
        payload: id
    }),
    getMovimientos: (data) => ({
        type: actions.GET_MOVIMIENTOS_REQUEST,
        filters: data,
    }),
    getMovimientosInformes: (data) => ({
        type: actions.GET_MOVIMIENTOS_INFORMES_REQUEST,
        filters: data,
    }),
    createMovimiento: (data, history) => ({
        type: actions.CREATE_MOVIMIENTO_REQUEST,
        payload: data,
        history
    }),
    getCierres: (data) => ({
        type: actions.GET_CIERRES_REQUEST,
        filters: data,
    }),
    createCierre: (data) => ({
        type: actions.CREATE_CIERRE_REQUEST,
        payload: data,
    }),
    getSaldos: (data) => ({
        type: actions.GET_SALDOS_REQUEST,
        filters: data,
    }), 


};
export default actions;